import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/sign',
      name: 'sign', //点击签约
      meta: {
        title: '签约',
        requireAuth: true
      },
      component: resolve => require(['@/views/signing/sign.vue'], resolve),
    },
    {
      path: '/unty',
      name: 'unty', //点击解约
      meta: {
        title: '解约',
        requireAuth: true
      },
      component: resolve => require(['@/views/signing/unty.vue'], resolve),
    },


    {
      path: '/',
      redirect: '/home'
    }, // 默认就跳转此页面


    {
      path: '/home',
      name: 'home',
      meta: {
        title: '首页',
      },
      component: resolve => require(['@/views/home/home.vue'], resolve),
    },
    {
      path: '/ContractInformation',
      name: 'ContractInformation',
      meta: {
        title: '签约信息',
      },
      component: resolve => require(['@/views/home/ContractInformation.vue'], resolve),
    },
    {
      path: '/Usermessage',
      name: 'Usermessage',
      meta: {
        title: '用户信息'
      },
      component: resolve => require(['@/views/home/Usermessage.vue'], resolve),
    },
    {
      path: '/Searchorder',
      name: 'Searchorder',
      meta: {
        title: '查询订单'
      },
      component: resolve => require(['@/views/home/Searchorder.vue'], resolve),
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {
        title: '客户签约'
      },
      component: resolve => require(['@/views/signing/privacy.vue'], resolve),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js